import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';
import { createBrowserHistory } from 'history';
import { Header, Footer } from 'components';
import routing from './routes';
import { I18nContext } from './utils/translationStrings';
import './styles/App.scss';

require('dotenv').config();

class App extends React.Component {
  static propTypes = {
    setLanguage: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.changeLocale = this.changeLocale.bind(this);
    this.setLanguageToThePath = this.setLanguageToThePath.bind(this);
    this.state = this.setLanguageToThePath();
  }

  setLanguageToThePath() {
    const allAvailableLanguages = process.env.REACT_APP_LANGUAGE_LIST.split(',');
    const { setLanguage } = this.props;
    const history = createBrowserHistory();
    const currentLocationArray = this.getLocalizationArray();
    const defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;
    const state = {
      languages: allAvailableLanguages,
      history: history
    };

    if (currentLocationArray.length && currentLocationArray[0].length === 0) {
      currentLocationArray.shift();
    }

    const potentialLanguage = this.getLocalizationArray()[0];

    if (allAvailableLanguages.indexOf(potentialLanguage) !== -1) {
      state.lang = potentialLanguage;
      setLanguage(potentialLanguage);
    } else {
      currentLocationArray.unshift(defaultLanguage);
      state.lang = defaultLanguage;
      const nextLocationPath = currentLocationArray.join('/');
      history.push(`/${nextLocationPath}`);
    }
    return (state);
  }

  getLocalizationArray() {
    const currentLocationArray = window.location.pathname.split('/');
    if (currentLocationArray.length && currentLocationArray[0].length === 0) {
      currentLocationArray.shift();
    }
    return currentLocationArray;
  }

  changeLocale(lang) {
    const { setLanguage } = this.props;
    const { languages, history } = this.state;
    const currentLocationArray = this.getLocalizationArray();
    const potentialLanguage = currentLocationArray[0];

    setLanguage(lang);

    if (languages.indexOf(potentialLanguage) !== -1) {
      currentLocationArray.splice(0, 1, lang);
    }

    const nextLocationPath = currentLocationArray.join('/');
    history.push(`/${nextLocationPath}`);
    history.replace(`/${nextLocationPath}`);

    this.setState({ lang });
  }

  render() {
    const { lang } = this.state;
    return (
      <ParallaxProvider>
        <Router>
          <div className="Application full-page">
            <Header
              setLanguage={this.changeLocale}
              lang={lang}
            />
            {routing}
            <Footer lang={lang} />
          </div>
        </Router>
      </ParallaxProvider>
    );
  }
}

export default I18nContext(App);



// WEBPACK FOOTER //
// ./src/App.js